import React, { useEffect } from 'react';
import { Progress, Typography } from 'antd';
import { BaseType } from 'antd/lib/typography/Base';

import './Initialization.scss';

import SolgariLogo from '@/public/images/solgari-logo.png';
import { useStore } from '../../stores';

const { Paragraph, Text } = Typography;

interface IView {
  text: string;
  color: BaseType;
}

export interface IPrompt {
  dynScript: IView;
  dynLogin: IView;
  sipLogin: IView;
}

export interface IInitialization {
  percent: number;
  prompt: IPrompt;
}

export function Initialization() {
  const {
    settingsStore: { initializationState },
  } = useStore();
  const setCurrentTabAsActive = () => {
    localStorage.removeItem('originalSolgariCallSessionTab');
    localStorage.removeItem('uniqueSolgariBrowserId');
    sessionStorage.removeItem('uniqueSolgariBrowserId');
  };
  useEffect(() => {
    setCurrentTabAsActive();
  }, []);

  return (
    <div className="initialization">
      <img src={SolgariLogo} alt="logo" />
      <Paragraph className="initialization__info">
        Application is going to initialize all components, it does not take a
        lot of time. Do not miss popup with Dynamics 365 verification in order
        to start using it.
      </Paragraph>
      <Paragraph className="initialization__prompts">
        <div>
          Dynamics script:{' '}
          <Text
            className="initialization__prompt"
            type={initializationState.prompt?.dynScript.color}
          >
            {initializationState.prompt?.dynScript.text}
          </Text>
        </div>
        <div>
          Dynamics 365 verification:{' '}
          <Text
            className="initialization__prompt"
            type={initializationState.prompt.dynLogin.color}
          >
            {initializationState.prompt.dynLogin.text}
          </Text>
        </div>
        <div>
          Sip verification:{' '}
          <Text
            className="initialization__prompt"
            type={initializationState.prompt.sipLogin.color}
          >
            {initializationState.prompt.sipLogin.text}
          </Text>
        </div>
      </Paragraph>
      <Progress type="circle" percent={initializationState.percent} />
    </div>
  );
}
